import { createExternalRouteRef, createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

const registerComponentRouteRef = createExternalRouteRef({
  id: "register-component",
  optional: true,
  defaultTarget: "catalog-import.importPage"
});
const viewTechDocRouteRef = createExternalRouteRef({
  id: "view-techdoc",
  optional: true,
  params: ["namespace", "kind", "name"],
  defaultTarget: "techdocs.docRoot"
});
const rootRouteRef = createRouteRef({
  id: "scaffolder"
});
createSubRouteRef({
  id: "scaffolder/legacy/selected-template",
  parent: rootRouteRef,
  path: "/templates/:templateName"
});
const selectedTemplateRouteRef = createSubRouteRef({
  id: "scaffolder/selected-template",
  parent: rootRouteRef,
  path: "/templates/:namespace/:templateName"
});
const scaffolderTaskRouteRef = createSubRouteRef({
  id: "scaffolder/task",
  parent: rootRouteRef,
  path: "/tasks/:taskId"
});
const scaffolderListTaskRouteRef = createSubRouteRef({
  id: "scaffolder/list-tasks",
  parent: rootRouteRef,
  path: "/tasks"
});
const actionsRouteRef = createSubRouteRef({
  id: "scaffolder/actions",
  parent: rootRouteRef,
  path: "/actions"
});
const editRouteRef = createSubRouteRef({
  id: "scaffolder/edit",
  parent: rootRouteRef,
  path: "/edit"
});

export { actionsRouteRef, editRouteRef, registerComponentRouteRef, rootRouteRef, scaffolderListTaskRouteRef, scaffolderTaskRouteRef, selectedTemplateRouteRef, viewTechDocRouteRef };
//# sourceMappingURL=routes.esm.js.map
